import { useRealtimeHealthStore } from "../../stores/realtimeHealthStore";

export function useRealtimeHealth() {
    return useRealtimeHealthStore((s) => s.status);
}